// SEO metadata for all pages
export const seoData = {
  home: {
    title: "HappyVan | Furniture Removals Brighton | Man and Van Service",
    description: "Furniture removals in Brighton & Hove. Fully insured local team, house moves, man and van and deliveries. Call or WhatsApp us for a quote.",
    canonical: "https://www.happyvan.co/",
    ogImage: "https://www.happyvan.co/og-image.png"
  },
  services: {
    title: "Removals Services Brighton & Hove | House & Office Moves | HappyVan",
    description: "House removals, office moves, man and van, packing and storage in Brighton. Fully insured, professional service. Free quotes.",
    canonical: "https://www.happyvan.co/services",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  getQuote: {
    title: "Get a Removals Quote | Brighton, Hove & Sussex | HappyVan",
    description: "Get a price for your Brighton or Sussex move. Call us or send a WhatsApp message and we'll quote you directly - no lengthy forms.",
    canonical: "https://www.happyvan.co/get-quote",
    ogImage: "https://www.happyvan.co/og-image.png"
  },
  partners: {
    title: "Partner With HappyVan | Estate Agents & Letting Agents | Brighton",
    description: "Partner with Brighton's trusted removal company. Referral programme for estate and letting agents.",
    canonical: "https://www.happyvan.co/partners",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  privacy: {
    title: "Privacy Policy | HappyVan Brighton Removals",
    description: "HappyVan privacy policy. How we collect, use and protect your personal data.",
    canonical: "https://www.happyvan.co/privacy",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  terms: {
    title: "Terms of Service | HappyVan Brighton Removals",
    description: "Terms and conditions for HappyVan furniture removal services in Brighton and Sussex.",
    canonical: "https://www.happyvan.co/terms",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  houseRemovalsBrighton: {
    title: "House Removals Brighton & Hove | Fully Insured | HappyVan",
    description: "Professional house removals in Brighton & Hove. Fully insured, experienced team. Free quotes available.",
    canonical: "https://www.happyvan.co/house-removals-brighton",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  manAndVanBrighton: {
    title: "Man and Van Brighton | Hourly Rates | HappyVan",
    description: "Affordable man and van service in Brighton. Hourly rates, same-day availability, professional service.",
    canonical: "https://www.happyvan.co/man-and-van-brighton",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  officeRemovalsBrighton: {
    title: "Office Removals Brighton | Commercial Moves | HappyVan",
    description: "Professional office removals in Brighton. Weekend and evening availability, fully insured.",
    canonical: "https://www.happyvan.co/office-removals-brighton",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  removalsHove: {
    title: "Removals Hove | House Moves & Man and Van | HappyVan",
    description: "Local removals company serving Hove. House moves, man and van, office relocations. Free quotes.",
    canonical: "https://www.happyvan.co/removals-hove",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  removalsEastSussex: {
    title: "Removals East Sussex | Lewes, Worthing, Shoreham & More | HappyVan",
    description: "Removals across East Sussex including Lewes, Worthing, Shoreham. Professional moving service.",
    canonical: "https://www.happyvan.co/removals-east-sussex",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  packingMaterialsBrighton: {
    title: "Moving Boxes & Packing Materials Brighton | Free Delivery | HappyVan",
    description: "Quality moving boxes and packing materials in Brighton. Free local delivery available.",
    canonical: "https://www.happyvan.co/packing-materials-brighton",
    ogImage: "https://www.happyvan.co/happyvan-logo.png"
  },
  blog: {
    title: "Moving Tips & Advice Blog | HappyVan Brighton",
    description: "Practical moving advice from a Brighton removals team. Costs, van sizes, packing and local guides for Brighton, Hove and Sussex moves.",
    canonical: "https://www.happyvan.co/blog",
    ogImage: "https://www.happyvan.co/og-image.png"
  },
  studentRemovalsBrighton: {
    title: "Student Removals Brighton | Sussex & Brighton Uni Moves | HappyVan",
    description: "Student removals in Brighton for Sussex and Brighton Uni moves. End of term clearances, hall to house moves and summer storage. Call or WhatsApp us.",
    canonical: "https://www.happyvan.co/student-removals-brighton",
    ogImage: "https://www.happyvan.co/og-image.png"
  },
  pianoRemovalsBrighton: {
    title: "Piano Removals Brighton | Upright & Grand Piano Movers | HappyVan",
    description: "Specialist piano removals in Brighton and Sussex. Uprights, baby grands and grand pianos moved with the right equipment and protection.",
    canonical: "https://www.happyvan.co/piano-removals-brighton",
    ogImage: "https://www.happyvan.co/og-image.png"
  },
  winYourMove: {
    title: "Win Your Move Back - Up to £500 | HappyVan Brighton",
    description: "Book any move with HappyVan and you're automatically entered into our monthly prize draw, at no extra cost. One customer a month wins their move cost back, up to £500.",
    canonical: "https://www.happyvan.co/win-your-move",
    ogImage: "https://www.happyvan.co/og-image.png"
  },
  furnitureDeliveryBrighton: {
    title: "Furniture Delivery Brighton | Sofa, Bed & Store Collections | HappyVan",
    description: "Furniture delivery and collection across Brighton and Hove. Sofas, beds, single items and store or marketplace pickups. Same-day often available.",
    canonical: "https://www.happyvan.co/furniture-delivery-brighton",
    ogImage: "https://www.happyvan.co/og-image.png"
  }
};

// Blog posts data
export const blogPosts = [
  {
    id: 1,
    slug: "how-much-does-it-cost-to-move-house-in-brighton",
    title: "How Much Does It Cost to Move House in Brighton?",
    metaTitle: "How Much Does Moving House Cost in Brighton? | 2026 Price Guide | HappyVan",
    metaDescription: "Discover realistic house moving costs in Brighton for 2026. From studio flats to 5-bed homes, we break down pricing factors and give you accurate estimates.",
    excerpt: "Planning a move in Brighton? Here's everything you need to know about removal costs, from studio flats to large family homes.",
    date: "2026-02-15",
    author: "HappyVan Team",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
    content: `
Moving house is one of life's biggest undertakings, and understanding the costs involved helps you budget effectively. As a Brighton and Hove based removals team, we're sharing what we see day to day so you know what to expect for a house move in Brighton and Hove in 2026.

## Factors That Affect Your Moving Costs

Several key factors determine how much your Brighton house move will cost:

### 1. Property Size
The size of your home directly impacts the time, manpower, and vehicle space needed. Here's a rough guide for local Brighton moves:

- **Studio/1-bed flat**: £250 - £400
- **2-bed flat/house**: £350 - £550
- **3-bed house**: £500 - £800
- **4-bed house**: £700 - £1,100
- **5+ bed house**: £1,000 - £1,800+

### 2. Distance
Moving within Brighton and Hove is typically charged differently to longer distance moves:

- **Local moves** (within Brighton & Hove): Usually a fixed rate or hourly
- **Regional moves** (East/West Sussex): Priced per mile plus loading time
- **National moves**: Full-day or multi-day rates apply

### 3. Access Difficulties
Brighton's Victorian architecture presents unique challenges. Costs may increase if you have:

- Narrow staircases in period conversions
- No lift access in upper-floor flats
- Limited parking requiring permit arrangements
- Basement flats with steep steps

### 4. Time of Year
Moving costs can vary by up to 30% depending on when you move:

- **Peak season** (May-September): Higher demand, higher prices
- **Month-end**: Busiest time - book 4-6 weeks ahead
- **Mid-week moves**: Often 10-15% cheaper than weekends
- **Winter months**: Best rates and availability

### 5. Additional Services
Beyond basic loading and transport, you might need:

- **Packing service**: £150 - £400 depending on property size
- **Packing materials**: £50 - £150 for boxes, tape, bubble wrap
- **Furniture disassembly/reassembly**: £50 - £100
- **Temporary storage**: From £25 per week
- **End of tenancy cleaning**: £150 - £350

## Getting an Accurate Quote

The best way to get an accurate moving quote is to provide as much detail as possible:

1. **Complete inventory** of items to be moved
2. **Access information** for both properties
3. **Parking situation** at pickup and delivery
4. **Any items requiring special handling** (pianos, antiques, gym equipment)
5. **Preferred moving date** and any time constraints

At HappyVan, the quickest way to get a price is simply to talk to us:
- **Call us** - tell us the property size and access and we'll price it on the call
- **WhatsApp us** - send a message (photos of tricky items help) and we'll come back with a price
- **In-person survey** - for larger or more complex moves

## Why Choose a Professional Removal Company?

While it might be tempting to hire a van and do it yourself, professional movers offer:

- **Insurance protection** - Your belongings are covered if anything goes wrong
- **Proper equipment** - Trolleys, straps, blankets and tools
- **Experience** - We know how to protect furniture and navigate tight spaces
- **Efficiency** - A trained team works much faster than inexperienced helpers
- **Less stress** - Focus on the other aspects of your move

## Ready to Get Your Quote?

Contact HappyVan today for a free, no-obligation quote for your Brighton house move. Whether you're moving from a Kemptown flat or a Hove townhouse, we're here to make your move as smooth as possible.
    `,
    faqs: [
      {
        question: "How much does a house removal cost in Brighton?",
        answer: "House removal costs in Brighton typically range from £250 for a studio flat to £1,800+ for a large 5+ bedroom house. The exact price depends on factors like property size, distance, access difficulties, and additional services required."
      },
      {
        question: "How far in advance should I book a removal company in Brighton?",
        answer: "We recommend booking 2-4 weeks ahead for most moves, and 4-6 weeks for peak times (summer and month-ends). However, HappyVan can often accommodate short-notice moves, sometimes even same-day."
      },
      {
        question: "Is it cheaper to move house on a weekday?",
        answer: "Yes, mid-week moves (Tuesday-Thursday) are typically 10-15% cheaper than weekend moves. Monday and Friday prices sit somewhere in between."
      },
      {
        question: "Do removal companies in Brighton charge by the hour or a fixed rate?",
        answer: "It varies. For local moves within Brighton, many companies including HappyVan offer both hourly rates for smaller moves and fixed quotes for larger moves where a full inventory has been provided."
      },
      {
        question: "What's included in a standard removal quote?",
        answer: "A standard removal quote typically includes loading at the pickup address, transport in a removal van, and unloading at the delivery address. Packing, materials, storage, and assembly services are usually priced separately."
      }
    ]
  },
  {
    id: 2,
    slug: "what-size-van-do-i-need-for-a-house-move",
    title: "What Size Van Do I Need for a House Move?",
    metaTitle: "What Size Van Do I Need for Moving House? | Van Size Guide | HappyVan",
    metaDescription: "Not sure what size removal van you need? Our guide explains Luton van capacity, what fits inside, and when you might need multiple trips or a larger vehicle.",
    excerpt: "Choosing the right van size is crucial for an efficient move. Here's our expert guide to removal van sizes and what they can fit.",
    date: "2026-02-10",
    author: "HappyVan Team",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1742858492775-8f58f645aa12?w=800",
    content: `
One of the most common questions we get at HappyVan is "what size van do I need?" Getting this right is important - too small and you'll need multiple trips (costing more), too large and you're paying for space you don't need.

## Understanding Van Sizes

Removal vans come in several sizes, but the most common for house moves are:

### Small Van (SWB - Short Wheelbase)
- **Capacity**: 6-8 cubic metres
- **Best for**: Single items, student moves, small studio flats
- **Fits**: A sofa OR a bed plus some boxes, but not both

### Medium Van (LWB - Long Wheelbase)
- **Capacity**: 10-12 cubic metres
- **Best for**: Studio to 1-bed flat moves
- **Fits**: Bed, small sofa, dining table, 20-30 boxes

### Luton Van (3.5 Tonne)
- **Capacity**: 18-20 cubic metres
- **Best for**: 1-3 bedroom house moves
- **Fits**: Complete contents of most 2-bed properties in one trip

At HappyVan, we use 3.5-tonne long wheelbase Luton vans - the largest you can drive on a standard licence and the most versatile for house moves.

## What Fits in a Luton Van?

Our Luton vans have approximately 20 cubic metres of space. Here's what typically fits:

### One Full Load Can Include:
- 3-seater sofa
- 2-seater sofa or armchair
- Double bed with mattress
- Wardrobe (or 2 smaller ones)
- Chest of drawers
- Dining table with 4-6 chairs
- Washing machine
- Fridge/freezer
- 30-50 moving boxes
- Various small items and bags

### Property Size Guide:
- **Studio flat**: 1 Luton van, possibly with space to spare
- **1-bed flat**: 1 Luton van, full load
- **2-bed flat/house**: 1 Luton van, tightly packed OR 1.5 loads
- **3-bed house**: 1.5 - 2 Luton van loads
- **4-bed house**: 2 - 2.5 Luton van loads
- **5+ bed house**: 3+ Luton van loads or larger vehicle

## When You Might Need Multiple Trips

Even with our large Luton vans, you might need more than one trip if you have:

- **Large furniture pieces**: American-style fridge freezers, super king beds, large corner sofas
- **Garden furniture and equipment**: Outdoor sets, BBQs, lawn mowers
- **Garage contents**: Tools, bikes, storage items
- **Home gym equipment**: Treadmills, weight benches, exercise bikes

## Tips for Maximising Van Space

Our experienced team knows how to load a van efficiently, but here are some tips:

1. **Dismantle furniture** where possible - bed frames, dining tables, wardrobes
2. **Fill hollow spaces** - inside drawers, washing machine drums, empty boxes
3. **Stack boxes heaviest at bottom**, lightest on top
4. **Use soft items as padding** - duvets, pillows, cushions protect fragile items
5. **Load large items first**, then fill gaps

## How We Calculate Your Van Requirements

When you request a quote from HappyVan, we assess:

1. **Total volume** of your belongings
2. **Any oversized items** that take extra space
3. **Access restrictions** that might affect loading
4. **Distance** between properties (affects whether multiple trips are practical)

A quick phone call or WhatsApp message gives us the detail we need to recommend the right van and crew for your move.

## Get a Personalised Assessment

Not sure how much you're moving? Send us a quick WhatsApp video walking through your property, and we'll tell you exactly what you need - no obligation, no guesswork.
    `,
    faqs: [
      {
        question: "What size van do I need for a 2-bed house?",
        answer: "A 2-bedroom house typically requires one 3.5-tonne Luton van, though it may be a tight fit. If you have a lot of furniture or bulky items, you might need 1.5 loads or a second trip."
      },
      {
        question: "How much can you fit in a Luton van?",
        answer: "A standard 3.5-tonne Luton van holds approximately 20 cubic metres. This typically accommodates the contents of a 1-2 bedroom property including a sofa, bed, wardrobe, dining set, appliances and 30-50 boxes."
      },
      {
        question: "Is it cheaper to do two trips or hire a bigger van?",
        answer: "For local moves within Brighton, two trips in a Luton van is often more economical than hiring a larger 7.5-tonne vehicle which requires a special licence and has higher running costs."
      },
      {
        question: "Can you move a piano in a Luton van?",
        answer: "Yes, upright pianos can be moved in a Luton van with proper equipment. Grand pianos require specialist handling. Piano moves are priced separately due to the extra care and equipment needed."
      },
      {
        question: "What if I have more stuff than I thought?",
        answer: "If we discover on moving day that there's more to move than quoted, we'll discuss options with you. This might mean a second trip, temporary storage, or rescheduling non-essential items."
      }
    ]
  },
  {
    id: 3,
    slug: "guide-to-moving-house-in-brighton",
    title: "A Local Mover's Guide to Moving in Brighton",
    metaTitle: "Moving House in Brighton: A Local's Guide | Tips & Advice | HappyVan",
    metaDescription: "Planning a move in Brighton? Get insider tips from local removal experts on parking permits, best days to move, avoiding traffic, and preparing for narrow streets.",
    excerpt: "Brighton has its quirks when it comes to moving house. Here's our local expert guide to navigating a Brighton move successfully.",
    date: "2026-02-05",
    author: "HappyVan Team",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1775676143321-ca3fc08916ba?w=800",
    content: `
Moving people around Brighton and Hove day in, day out teaches you what makes a move go smoothly in this city. From Victorian terraces to seafront apartments, here's our local guide to moving house in Brighton.

## Understanding Brighton's Moving Challenges

Brighton isn't like other cities. Our narrow Regency streets, permit parking zones, and period properties create unique challenges that out-of-town removal companies often underestimate.

### Parking Permits - Essential Reading

Most of central Brighton and Hove operates resident permit parking zones. If you're moving to or from a permit zone, you'll need to arrange parking bay suspensions:

**How to Get a Parking Suspension:**
1. Apply to Brighton & Hove Council at least 5 working days in advance
2. Cost is approximately £30-50 per bay, per day
3. Specify the exact bays you need suspended
4. You'll receive cones and signs to mark the space

**Pro Tip**: Book more space than you think you need. A Luton van takes up about 2-3 standard parking bays. If parking is tight, we might need to shuttle items from a nearby loading bay.

### The Best Days to Move in Brighton

**Avoid if possible:**
- Friday afternoons (traffic nightmare on the A23/A27)
- Bank holiday weekends
- Brighton Pride weekend (August)
- Marathon day (usually April)
- Conference season at the Brighton Centre

**Best times:**
- Tuesday, Wednesday, Thursday
- Early morning starts (beat the traffic)
- Mid-month (quieter than month-end)
- September-February (off-peak moving season)

### Brighton Traffic Survival Guide

Getting around Brighton with a removal van requires local knowledge:

**Morning Rush (7:30-9:30am)**
- Lewes Road: Gridlocked - avoid completely
- London Road: Heavy but moving
- Western Road: Usually OK westbound

**School Run (3-4pm)**
- Avoid residential areas in Hove
- Surrenden Road area congested
- Preston Park very slow

**Seafront**
- Summer weekends: Forget it
- Parking almost impossible between the piers
- Palace Pier to West Pier is particularly bad

**Our Recommended Routes:**
- North to South: Via Ditchling Road or A23
- East to West: A27 bypass then down into town
- Avoid Seven Dials junction at all costs during peak hours

## Navigating Brighton Properties

### Victorian Terraces
Brighton's beautiful period properties come with challenges:

- **Narrow hallways**: Measure doorways before moving day
- **Tight staircases**: Some furniture may need to come in through windows
- **Basement flats**: Often have steep exterior steps
- **High ceilings**: Great for living, tricky for wardrobes

**What to Tell Us:**
- Staircase width and any turns
- Front door dimensions
- Whether there's a back entrance
- Garden access for ground floor properties

### Seafront Apartments
Living with a sea view is wonderful, but moving there requires planning:

- **High-rise buildings**: Check lift dimensions and booking requirements
- **Loading bays**: Often limited or non-existent
- **Wind exposure**: Can affect timing of lifts and hoists
- **Concierge buildings**: May have specific moving hour restrictions

### New Build Developments
Brighton has many new developments, each with their own rules:

- **Check access hours**: Some restrict moves to weekdays only
- **Book the lift**: Larger developments require advance lift booking
- **Loading areas**: Usually limited - may need to shuttle from nearby

## Packing Tips for Brighton Homes

### Dealing with Damp
Brighton's sea air means many properties have some damp issues:

- Use plastic boxes for items going into storage
- Wrap soft furnishings in plastic
- Don't pack damp items - let them air first
- Tell us about any damp concerns

### Protecting Period Features
- Remove door handles if they catch on furniture
- Protect cornices and picture rails
- Cover original floorboards
- Mind the dado rails on narrow staircases

## Local Services You Might Need

**Parking Permits:**
Brighton & Hove Council - www.brighton-hove.gov.uk

**Utility Connections:**
- Southern Water
- UK Power Networks
- SGN (gas)

**Council Tax:**
Notify both your old and new councils

**Electoral Roll:**
Update your registration online at gov.uk

## Final Checklist for Brighton Moves

**One Week Before:**
- Confirm parking suspension in place
- Check weather forecast
- Start defrosting freezer
- Confirm times with removal company

**Day Before:**
- Pack final boxes
- Prepare a "first night" box with essentials
- Check parking cones are in place
- Take photos of how electronics are connected

**Moving Day:**
- Be ready for your 8am start time
- Keep phone charged for updates
- Have cash for parking meters if needed
- Keep important documents with you

## Why Choose a Brighton-Based Remover?

Local knowledge matters. At HappyVan, we know:

- Which streets have width restrictions
- Where the traffic cameras are
- How to navigate the Laines with a van
- Which buildings have helpful porters
- The back routes when the main roads are blocked

Ready to plan your Brighton move? Get in touch with HappyVan for expert local service and honest advice.
    `,
    faqs: [
      {
        question: "Do I need a parking permit to move house in Brighton?",
        answer: "If you're moving to or from a controlled parking zone (most of central Brighton and Hove), you'll need to arrange a parking bay suspension with the council. This costs approximately £30-50 per bay and should be arranged at least 5 working days in advance."
      },
      {
        question: "What's the best day of the week to move house in Brighton?",
        answer: "Tuesday, Wednesday and Thursday are generally best - less traffic than Friday, cheaper than weekends, and removal companies often have better availability. Avoid Friday afternoons due to heavy traffic on routes out of Brighton."
      },
      {
        question: "Can a removal van get down my narrow Brighton street?",
        answer: "Most Brighton streets can accommodate a Luton van, though some very narrow streets may require us to park at the end and carry items further. When you get a quote, let us know about any access concerns and we'll advise on the best approach."
      },
      {
        question: "How early should I book a removal company in Brighton?",
        answer: "For peak times (summer weekends, month-ends), book 4-6 weeks ahead. For mid-week or off-peak moves, 1-2 weeks is usually fine. We can sometimes accommodate same-day bookings for urgent moves."
      },
      {
        question: "Are there any days I should avoid moving in Brighton?",
        answer: "Yes - Brighton Pride weekend (August), Marathon day (usually April), and any major events at the Brighton Centre can make moving extremely difficult due to road closures and traffic. Bank holiday weekends are also very busy."
      }
    ]
  },
  {
    id: 4,
    slug: "moving-a-3-bed-house-in-brighton-what-happens-on-the-day",
    title: "Moving a 3-Bed House in Brighton: What Actually Happens on the Day",
    metaTitle: "Moving a 3-Bed House in Brighton: Moving Day Timeline | HappyVan",
    metaDescription: "A hour-by-hour look at moving day for a 3-bed Brighton house move: crew, van, load order, parking, and the things that slow a move down.",
    excerpt: "Most people have never watched a full house move from start to finish. Here's how a 3-bed Brighton move actually runs, step by step.",
    date: "2026-06-04",
    author: "HappyVan Team",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1694715669993-ea0022b470f7?w=800",
    content: `
If you've only ever moved a flat with a couple of mates and a hire van, a 3-bed house move looks like a different sport. There's a crew, a load order, protection going down on floors, and a running conversation about what goes where at the other end.

Here's what a typical local 3-bed move looks like when we do it, so nothing on the day comes as a surprise.

## Before the day: the bits that decide how smoothly it goes

Two things make the biggest difference to a 3-bed move, and both are sorted before anyone picks up a box.

**Parking.** If either address sits in a controlled parking zone - which covers a lot of Brighton and Hove - we want that dealt with in advance, not discovered on the morning. A suspended bay or dispensation outside the door can save hours of carrying. We walk you through this in our [Brighton parking and bay suspension checklist](/blog/brighton-parking-permits-bay-suspensions-moving-checklist).

**Packing.** Furniture, appliances and anything awkward are our job. Small, loose items in cupboards and drawers are what stretch a move into the evening. If you'd rather not pack, say so when you book and we'll quote for it - and we can drop [boxes and materials](/packing-materials-brighton) off beforehand.

The night before, leave out a "last box" of kettle, mugs, tea, loo roll, phone chargers, chargers for the kids' things, medication and paperwork. Keep it with you, not in the van.

## Early morning: arrival and the walk-round

We arrive at the agreed time and the first thing we do is walk the house with you. That walk-round covers:

- What's coming and what's staying (the shed, the curtains, the fitted wardrobes)
- Anything fragile, sentimental or unusually heavy
- Items that need dismantling
- Which room at the new place each big piece belongs in

At the same time, the van gets set up: ramps out, blankets and covers ready, floor protection down on the hallway and stairs, and door frames padded on tight turns.

If you've got pets or small children, this is the moment to have a plan. An open front door, a van ramp and a stream of people carrying furniture is not a great combination with a nervous cat.

## Loading: it isn't random

A well-loaded van is why your wardrobe arrives the same shape it left. The order usually runs:

1. **Heavy, square, stackable items first** - white goods, wardrobes, chests of drawers, bookcases. These build the "wall" at the front of the van.
2. **Boxes** next, heaviest at the bottom, in blocks that can't shift.
3. **Soft furnishings and mattresses** as padding between hard items.
4. **Awkward, fragile and last-in-first-out pieces** - mirrors, TVs, glass shelves, lamps, and whatever you need first at the other end.

Beds, some wardrobes and big table tops get dismantled as we go. Fixings go in labelled bags and stay with us so they can't vanish into a box.

## What slows a 3-bed move down

Honest list, in rough order of how often it costs time:

- **Carry distance.** No parking outside means every item takes two or three times longer to move.
- **Stairs and turns.** Brighton's Victorian terraces have narrow hallways and quarter-turn staircases. We've written about that specifically in [Victorian terrace moves](/blog/victorian-terrace-moves-brighton-sofas-beds-wardrobes-staircases).
- **Loft, shed, garage and garden.** These are almost always underestimated. Have them cleared and boxed beforehand if you can.
- **Half-packed rooms.** A kitchen cupboard that still has food in it stops the crew until someone deals with it.
- **Keys not released.** If the other end isn't ready, everyone waits. It happens - and it's why we build a sensible plan rather than a stopwatch.

## In transit and unloading

Local moves across Brighton and Hove are short runs, so the van is usually only in transit a few minutes. Longer runs out to [Worthing](/removals-worthing), [Lewes](/removals-lewes) or [Eastbourne](/removals-eastbourne) get factored into the plan when we quote.

At the new place we repeat the same routine in reverse: walk-round, protection down, then unload room by room. Boxes go to the room written on them, so label the **room**, not the contents - "Kitchen" beats "mugs and plates" every time.

Beds get rebuilt first. That's deliberate: however chaotic the rest of the house is, everyone can sleep.

## End of day

Before we leave we'll:

- Rebuild what we dismantled and reconnect anything you'd like us to position
- Take away the blankets, covers and protection
- Do a final check of the van and the old property
- Flatten and remove packing debris if that's part of your booking

Then you get the fun job of finding the box with the coffee in it.

## The short version

A 3-bed local move is a full day's work for a proper crew, and most of the variables are decided before we arrive: parking, packing, and whether the loft and shed have been dealt with. Get those three right and the day is genuinely uneventful - which is exactly what you want.

Want to talk it through for your address? Call us or send a WhatsApp message and we'll tell you what your move needs. See [house removals in Brighton](/house-removals-brighton) for what's included, or [get a quote](/get-quote).
    `,
    faqs: [
      {
        question: "How long does a 3-bed house move in Brighton take?",
        answer: "Plan for it being a full day's work. The biggest variables are parking distance at both addresses, stairs and turns, and how much small packing is left when the crew arrives. When we quote we'll give you a realistic window for your two specific addresses."
      },
      {
        question: "Do I need to pack everything myself?",
        answer: "No. Furniture, appliances and awkward items are our job. Loose items in cupboards, drawers and wardrobes are what slow a move down, so either box those up beforehand or ask us to quote for packing when you book."
      },
      {
        question: "Will you dismantle and rebuild beds and wardrobes?",
        answer: "Yes - beds, flat-pack wardrobes and large table tops are routinely dismantled to get them out safely and rebuilt at the other end. Fixings are bagged, labelled and kept with the crew."
      },
      {
        question: "What happens if the keys to the new house are late?",
        answer: "It's common, so we plan for it rather than panic. Your belongings stay safely loaded and we wait or work around the delay. Tell us as soon as your solicitor flags a possible late completion and we'll adjust the plan."
      }
    ]
  },
  {
    id: 5,
    slug: "2-bed-flat-to-3-bed-house-moving-cost-difference",
    title: "2-Bed Flat to 3-Bed House: How Much More Does the Move Cost?",
    metaTitle: "2-Bed Flat to 3-Bed House: What Changes in Removal Costs | HappyVan",
    metaDescription: "Upsizing from a Brighton flat to a house? Here's what actually changes your removal cost - volume, crew, access and time - and how to keep it down.",
    excerpt: "Upsizing rarely costs more because of the extra bedroom. It costs more because of volume, access and time. Here's how each one works.",
    date: "2026-06-09",
    author: "HappyVan Team",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1552242718-c5360894aecd?w=800",
    content: `
Going from a 2-bed flat to a 3-bed house is the classic Brighton and Hove upsize: young family, second child on the way, or simply the need for a room that isn't also a desk.

People often assume removal pricing works like council tax - one band up, a bit more money. It doesn't. The cost of your move is driven by **how much there is, how hard it is to reach, and how long it takes**. The number of bedrooms is just a shorthand for those three things.

Here's what actually changes when you upsize.

## 1. Volume, not bedrooms

A 2-bed flat that's been lived in for two years and a 2-bed flat that's been lived in for ten can be completely different jobs. What matters is cubic metres: how much van space your belongings take up.

When you upsize, volume usually grows in three specific places:

- **Storage furniture** - the flat had one wardrobe, the house has three
- **Garden and outdoor kit** - the flat had none; the house brings a mower, bikes, a barbecue, garden furniture
- **The "we'll sort it later" pile** - loft boxes, spare bedding, tools, kids' equipment

If the volume grows past what fits in one van load, that's the single biggest jump in cost, because it can mean a second trip or a bigger vehicle and crew.

## 2. Crew size and time

More volume needs more hands to keep the day to a sensible length. Two people carrying a 3-bed house alone doesn't save money - it just turns a one-day move into a very long one, which costs more in the end and is far harder on everyone.

The practical question we're answering when we quote is: *what crew and vehicle get this done safely in a single, sensible day?*

## 3. Access at **both** ends

This is the one people forget. You're not just moving to a bigger property - you're moving between two different sets of obstacles.

Flats add: stairs, lifts (or no lift), narrow communal corridors, fire doors, restricted loading bays and sometimes a concierge with a booking sheet.

Houses add: a front path, steps up from the pavement, a hallway that turns, and a first floor that has to take wardrobes and mattresses.

And around most of central Brighton and Hove, both ends can sit in a controlled parking zone, which is why we push people to sort [parking and bay suspensions](/blog/brighton-parking-permits-bay-suspensions-moving-checklist) early. Carrying distance is one of the few things that reliably adds hours to a move.

## 4. Dismantling and rebuilding

Upsizing usually means more furniture that has to come apart: bed frames, flat-pack wardrobes, big dining tables, sometimes a corner sofa. That's skilled time, and it happens at both ends of the day.

It's also where damage happens when it's rushed - especially with flat-pack that was built in situ and was never designed to travel assembled.

## 5. Packing materials

A bigger home needs more boxes, more tape, more paper, more mattress and sofa covers. If you're buying your own, we sell [packing materials in Brighton](/packing-materials-brighton) and can drop them to you before the move.

## 6. The completion-day squeeze

Buying a house usually means completing on the same day you move, and often on a Friday. That compresses everything into a few hours and leaves no slack if keys are late. It doesn't change the physical work, but it does change how the day has to be planned - and Fridays and month-ends are the busiest slots in the diary. Our guide to [timing your move](/blog/best-time-to-move-house-brighton-hove) goes into that.

## How to keep the cost down when you upsize

- **Declutter before you get a quote, not after.** Charity shops, marketplace listings and the tip run are cheaper than moving things you don't want.
- **Clear the loft, shed and garage early.** These are the classic sources of "there's more than we thought".
- **Box the small stuff.** Furniture is quick; loose contents are slow.
- **Sort parking at both ends.** Free, and it can save serious time.
- **Be flexible on the day if you can.** Midweek is calmer than Friday for everyone involved.
- **Tell us about access honestly.** A second-floor flat with no lift and a 40-metre carry is fine if we know; it's a problem if we find out on the morning.

## Getting an accurate number

We don't price houses off bedroom counts alone. Tell us the two addresses, the floors, the parking situation and roughly what's coming - or send a few photos on WhatsApp of the bigger rooms, the wardrobes and the garden - and we'll give you a straight price.

For a general sense of local pricing, see our [Brighton moving cost guide](/blog/how-much-does-it-cost-to-move-house-in-brighton). For your move specifically, [call or WhatsApp us](/get-quote) - it takes a couple of minutes.
    `,
    faqs: [
      {
        question: "Does an extra bedroom automatically cost more to move?",
        answer: "Not by itself. Cost follows volume, access and time. A tidy 3-bed with parking outside and no stairs can be a quicker job than a cluttered 2-bed flat on the third floor with no lift."
      },
      {
        question: "Is it cheaper to do two smaller van trips?",
        answer: "Usually not. Two trips mean double the travel and loading time, and on a completion day you often don't have the hours available. We'll tell you when a bigger van or extra crew is the cheaper route."
      },
      {
        question: "Should I declutter before or after getting a quote?",
        answer: "Before. Anything you're getting rid of shouldn't be in the quote at all - and clearing the loft, shed and garage first is the fastest way to bring a move down to a single sensible load."
      },
      {
        question: "Can you move us if we're buying and selling on the same day?",
        answer: "Yes, that's the normal pattern. Tell us it's a same-day completion when you book so we can plan for a possible delay on keys, and let us know the moment your solicitor flags a problem."
      }
    ]
  },
  {
    id: 6,
    slug: "moving-out-of-brighton-to-sussex-hove-lewes-worthing-burgess-hill",
    title: "Moving Out of Brighton to Sussex: Hove, Lewes, Worthing or Burgess Hill?",
    metaTitle: "Moving Out of Brighton: Hove vs Lewes vs Worthing vs Burgess Hill | HappyVan",
    metaDescription: "Leaving Brighton for more space? A mover's view of Hove, Lewes, Worthing and Burgess Hill - housing, access, routes and what each move day involves.",
    excerpt: "We move people out of Brighton every week. Here's the mover's-eye view of the four towns people ask about most.",
    date: "2026-06-12",
    author: "HappyVan Team",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1659647475972-22674b51e9aa?w=800",
    content: `
The most common conversation we have with Brighton customers isn't about boxes. It's "we love it here, but we need another bedroom and somewhere to park".

We're not estate agents and we won't tell you where to live. But we do see the housing stock, the streets and the moving-day reality of these towns constantly, so here's the practical view of the four places people ask about most.

## Hove - the smallest jump

**Where it is:** next door. Most Hove moves are a short hop from Brighton.

**What you're moving into:** wide Victorian and Edwardian avenues around Palmeira and The Drive, seafront mansion blocks, converted flats, and more family houses with actual gardens as you go north and west towards Portslade.

**Moving day reality:** lots of Hove sits in controlled parking zones, and the big mansion blocks mean stairs, lifts and shared entrances. Upper-floor conversion flats with a single narrow staircase are the usual challenge. On the plus side, the journey itself is minutes, so a single van can do multiple runs if needed.

**Good fit if:** you want to keep the Brighton life and gain a bit of space and calm. More detail on [removals in Hove](/removals-hove).

## Lewes - character, hills and narrow lanes

**Where it is:** about eight miles north-east of Brighton, straight up the A27.

**What you're moving into:** Georgian townhouses, flint cottages, terraces on steep streets, plus village properties in the surrounding BN8 postcodes.

**Moving day reality:** Lewes is the most access-sensitive town on this list. Steep streets, twittens (the narrow alleyways the town is famous for), cobbles, conservation-area restrictions and terraces where the van simply cannot get to the door. It's all perfectly doable - it just needs planning and the right size vehicle rather than the biggest one. Bonfire Night (5 November) brings road closures, so it's not a date to move.

**Good fit if:** you want character and countryside with a quick run into Brighton and direct trains to London. More detail on [removals in Lewes](/removals-lewes).

## Worthing - space for the money, and a seafront

**Where it is:** about eleven miles west along the coast, via the A259 or A27.

**What you're moving into:** 1930s semis with driveways in Goring and Durrington, Victorian and Edwardian terraces near the centre, and seafront flats along the Brighton Road and Marine Parade.

**Moving day reality:** generally kinder than central Brighton - more driveways, more off-street parking, wider roads inland. The pinch points are seafront loading restrictions, one-way sections near the town centre, and permit zones around the station. Seafront flats can also mean lifts and long communal corridors.

**Good fit if:** you want more house for your money and don't mind being further west. More detail on [removals in Worthing](/removals-worthing).

## Burgess Hill - commuter practicality

**Where it is:** about fourteen miles north of Brighton via the A23.

**What you're moving into:** post-war and modern estates, new-build developments, and Victorian cottages near the station.

**Moving day reality:** the easiest of the four in most cases - driveways, wider streets, fewer permit zones. The catch is newer estates: narrow turning heads, resident-bay-only parking and tandem driveways can make positioning a large van awkward, so we plan the approach in advance. It's on the main London-Brighton railway line, which is why a lot of commuting families end up here.

**Good fit if:** you need a straightforward family house and a reliable commute. More detail on [removals in Burgess Hill](/removals-burgess-hill).

## And if you're going further

We regularly run moves to [Eastbourne](/removals-eastbourne) and [Shoreham-by-Sea](/removals-shoreham) too, and across the wider county - see [removals in East Sussex](/removals-east-sussex).

## Four things worth doing whichever town you pick

1. **Check the parking situation at the new address before moving day.** Different councils, different rules, different lead times. What works in Brighton doesn't necessarily apply in Lewes or Worthing.
2. **Measure the access at the new place.** Front door, hallway turn, staircase width, and whether the van can get within carrying distance.
3. **Tell us about both ends.** A long carry at one address changes the plan more than the distance between towns does.
4. **Book earlier than you think.** Out-of-Brighton moves are usually purchase completions, which cluster on Fridays and month-ends.

Want a price for a move out of Brighton? [Call or WhatsApp us](/get-quote) with the two addresses and we'll talk it through properly.
    `,
    faqs: [
      {
        question: "Do you charge more for moving out of Brighton to another Sussex town?",
        answer: "Distance is one factor among several - the drive to Worthing, Lewes, Burgess Hill or Eastbourne is factored into the quote alongside volume, access and time. Tell us both addresses and we'll give you a straight price."
      },
      {
        question: "Which nearby town is easiest to move into?",
        answer: "Generally the towns with more off-street parking and driveways - Burgess Hill and the inland parts of Worthing - are the most straightforward. Lewes is the most access-sensitive because of its steep, narrow streets and conservation area."
      },
      {
        question: "Can you do the move in one day if we're leaving Brighton?",
        answer: "For all four towns on this list, yes - these are short runs. What decides the day is volume and access at each end, not the mileage."
      },
      {
        question: "Do we need parking permits at both addresses?",
        answer: "Often yes, and the process differs by council. We'll tell you what's needed at each end when we quote so there's time to arrange it."
      }
    ]
  },
  {
    id: 7,
    slug: "brighton-parking-permits-bay-suspensions-moving-checklist",
    title: "Parking Permits & Bay Suspensions: The Brighton and Hove Mover's Checklist",
    metaTitle: "Brighton Parking for Moving Day: Permits & Bay Suspensions | HappyVan",
    metaDescription: "How to sort parking for a Brighton or Hove move: controlled parking zones, bay suspensions, dispensations and what to do on streets with no bays.",
    excerpt: "Nothing adds hours to a Brighton move like nowhere to park. Here's how to get the van to your front door.",
    date: "2026-06-17",
    author: "HappyVan Team",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1612983768853-7e9deb039bb9?w=800",
    content: `
If you take one piece of advice from this blog, make it this one: **sort your parking before moving day**.

Carrying distance is the single most reliable way to turn a straightforward move into a long, expensive day. Fifty metres of pavement between the van and your front door, repeated a few hundred times, adds hours. A bay outside the door removes that entirely.

Here's the checklist we give Brighton and Hove customers.

## 1. Work out whether you're in a controlled parking zone

Much of central Brighton and Hove sits in a controlled parking zone (CPZ). Look at the signs at the end of your street: they'll show the zone letter and the hours that restrictions apply. That sign is your starting point, because it determines what you're allowed to do on moving day and when.

Streets outside a CPZ aren't automatically easier - they're often the narrow, busy ones where there's simply nowhere to stop legally for long.

## 2. Know your three options

**Bay suspension.** The council takes a stretch of bays out of use for your move and signs it in advance, so the van has a guaranteed space. This is the gold standard for a house move with a large vehicle. There's a fee and a required notice period, and both are set by the council - check the current figures on the Brighton and Hove City Council website before you plan the date.

**Dispensation.** Permission for a vehicle to wait in a restricted place for a set period. Useful where suspending bays isn't practical.

**Visitor permits.** Fine for a car or a small van for a short job, but not a substitute for a suspended bay on a full house move.

## 3. Apply early - and earlier than you think for peak dates

Bay suspensions need lead time, and the council publishes the notice period it requires. Fridays and month-ends are the busiest moving days in the city, so apply as soon as your date is firm rather than the week before.

If your completion date is still moving around, tell us - we'd rather plan for the uncertainty than assume.

## 4. If there are no bays to suspend

Plenty of Brighton streets have no bays, just double yellows, single yellows or a very narrow carriageway. Options then:

- **Dispensation** for a defined window
- **Loading legally** on a single/double yellow where loading isn't specifically banned (check the kerb markings and signs - some streets prohibit loading at certain times)
- **A smaller vehicle** and a shuttle, which we'll sometimes recommend for steep or narrow streets
- **Early starts**, which genuinely help on residential streets where cars leave for work

We'll advise on which applies to your street when we quote.

## 5. Talk to your neighbours

It isn't a legal step, it's just effective. A knock on the door the evening before - "we're moving at 8, could you avoid parking across the front if you can?" - works remarkably often, and it's free.

## 6. Watch out for event days and road closures

Brighton has a busy events calendar and it can close roads with very little flexibility. Pride weekend in August, the marathon in the spring and large events at the Brighton Centre or the stadium all affect access. If your move lands on one of those dates, plan the route and timing around it - or move the date if you still can. Our guide to [choosing your moving date](/blog/best-time-to-move-house-brighton-hove) covers the local calendar.

## 7. Remember the other end

Half of moving day happens at the new address, and it might be in a different zone - or a different council entirely. Moving to [Hove](/removals-hove) is still Brighton and Hove City Council; moving to [Lewes](/removals-lewes), [Worthing](/removals-worthing), [Burgess Hill](/removals-burgess-hill) or [Eastbourne](/removals-eastbourne) means a different authority with its own process, fees and notice periods. Check both ends.

## The checklist, in order

1. Photograph the parking signs at both addresses
2. Identify the zone and hours at each end
3. Decide: suspension, dispensation or legal loading
4. Apply as soon as the date is firm, and confirm the notice period with the council
5. Check for event-day road closures on your date
6. Tell your removal company exactly what's in place
7. Knock on a couple of doors the night before
8. On the morning, get the van positioned before the street fills up

## One thing we can't do for you

Councils generally require the permit or suspension to be arranged by the resident or property occupier, so we can't apply on your behalf. What we can do is tell you what the van needs, how much kerb space to ask for, and how long we'll be there - which is usually the information the application asks for.

Ask us when you book. See [house removals in Brighton](/house-removals-brighton) or [get a quote](/get-quote).

**Fees and notice periods change, so always confirm the current details with the relevant council before you rely on them.**
    `,
    faqs: [
      {
        question: "Do I need a parking permit to move house in Brighton?",
        answer: "If either address is in a controlled parking zone you'll need a bay suspension, a dispensation or a valid permit for the removal vehicle. Check the signs at the end of the street, then confirm the current process, fee and notice period with Brighton and Hove City Council."
      },
      {
        question: "Can HappyVan arrange the bay suspension for me?",
        answer: "Councils normally require the resident or occupier to apply, so we can't do it for you. We will tell you the vehicle size, how much kerb space to request and how long we expect to be on site, which is what the application asks for."
      },
      {
        question: "What if there's nowhere legal to park outside my house?",
        answer: "It's common on narrow Brighton streets. Depending on the road we'll use a dispensation, load legally where loading isn't restricted, start early before the street fills up, or use a smaller vehicle and shuttle to a larger van."
      },
      {
        question: "Is the parking process the same in Hove, Lewes and Worthing?",
        answer: "Hove is the same council as Brighton. Lewes, Worthing, Burgess Hill and Eastbourne are different authorities with their own applications, fees and notice periods, so check the relevant council for the new address."
      }
    ]
  },
  {
    id: 8,
    slug: "victorian-terrace-moves-brighton-sofas-beds-wardrobes-staircases",
    title: "Victorian Terrace Moves: Getting Sofas, Beds and Wardrobes Up Brighton Staircases",
    metaTitle: "Victorian Terrace Moves in Brighton: Sofas, Beds & Staircases | HappyVan",
    metaDescription: "Brighton's Victorian terraces have narrow halls and tight stairs. How to measure, what dismantles, what doesn't fit, and how to protect original features.",
    excerpt: "Narrow hallway, quarter-turn stairs, a sofa that looked fine in the showroom. Here's how we get furniture into Brighton terraces.",
    date: "2026-06-20",
    author: "HappyVan Team",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1556971014-c739dd2a762f?w=800",
    content: `
Brighton and Hove has a lot of Victorian and Edwardian terraces, and they were not designed with corner sofas in mind. The hallway is narrow, the staircase turns, there's often a newel post exactly where you need the space, and the front door opens onto a step.

This is the type of property we work in most, so here's how we approach it - and what you can do before moving day to make it painless.

## Measure three things, not one

People measure the doorway. The doorway is rarely the problem.

1. **The door opening** - width and height, with the door removed if it's hinged into the space.
2. **The turn.** The point where a hallway meets the stairs, or where the stairs turn a corner, is the real constraint. Measure the width at the turn and the height to the ceiling or the underside of the landing.
3. **The diagonal.** Most sofas and mattresses go through tight spaces on the diagonal, not flat. The usable dimension is the diagonal of the gap, not the flat width.

Then measure the item itself at its **deepest** point - including feet, arms and cushions where they can't be removed.

If the numbers are close, tell us before the day. We'd rather plan than improvise on your staircase.

## What comes apart

Good news: a lot more than people expect.

- **Beds** - almost always dismantled. Divans split; frames come apart entirely.
- **Wardrobes** - flat-pack wardrobes usually come apart; solid or antique wardrobes sometimes have removable doors, backs or cornices.
- **Sofas** - many have removable feet and, on some models, removable arms or backs. Corner and modular sofas usually separate into sections.
- **Dining tables** - legs off, top through separately.
- **Desks, shelving units and cots** - generally straightforward.

What doesn't come apart is where planning matters: solid-frame sofas, one-piece armchairs, large mattresses in narrow stairwells, and oversized wall units.

## The flat-pack problem

Flat-pack furniture built in place - tall wardrobes and big bookcases especially - is often the riskiest thing in the house. The joints were tightened once, glued or cammed together, and never intended to be carried down stairs assembled or moved twice.

Sometimes the honest answer is that a unit will not survive the journey intact. We'll tell you that before we pick it up, not after, so you can decide whether to move it, dismantle it or replace it. We can rebuild flat-pack at the other end if you'd rather it travelled in pieces.

## When something genuinely won't fit

It happens, and there are options:

- **Remove the door** (and sometimes the door frame trim) to gain the extra centimetres
- **Take the item through a different route** - bay window rooms, basement entrances and garden access all help in terraces
- **Dismantle further** than the manufacturer intended, where it's safe and reversible
- **Hoist through a window** - rare, specialist and not something to assume; it needs assessing in advance
- **Reconsider placement** - a wardrobe that won't reach the top floor may work in the first-floor room

## Protecting the house, not just the furniture

Brighton terraces often still have the features people bought them for: original tiled hallway floors, moulded plaster, cast-iron bannisters, stained glass in the front door, stripped floorboards.

On our jobs that means floor protection through the hall and up the stairs, padding on door frames and the newel post, covers on mattresses and sofas, and blankets on anything with a corner. A scuffed wall is fixable; a cracked original tile is not.

Worth doing yourself: take pictures of anything precious before the move, and point it out at the walk-round.

## Basement flats, top-floor conversions and bay windows

Three Brighton specialities:

- **Basement and lower-ground flats** - steps down from the pavement, railings to work around, restricted head height. Carrying down is safer and slower than carrying along.
- **Loft conversions** - the final staircase is often the narrowest in the building, sometimes with a fixed handrail. Big bed frames may need dismantling to the last bolt.
- **Bay window rooms** - generous inside, but the doorway to them is often the tightest point in the house.

## And if you have a piano

Uprights and grands in terraces are a separate skill with their own kit. See [piano removals in Brighton](/piano-removals-brighton) - don't let a general crew wing it on a staircase.

## Before we arrive

- Clear the hallway, stairs and landings completely
- Take down anything hanging in the route: pictures, mirrors, coat hooks
- Remove loose rugs and runners
- Tell us about known tight spots, weak floorboards and anything precious
- Have a plan for pets and small children while the door is open

Then let us do the awkward part. That's what we're for.

Want us to look at a tricky access job? [Call or WhatsApp us](/get-quote) with a couple of photos of the hallway and staircase - it's usually all we need. See also [house removals in Brighton](/house-removals-brighton), [removals in Hove](/removals-hove) and [packing materials](/packing-materials-brighton).
    `,
    faqs: [
      {
        question: "What if my sofa won't fit through the door?",
        answer: "There's usually a way: removing the door and trim, taking the feet or arms off, trying a different route such as a bay window room or garden entrance, or dismantling further. Send us photos and measurements beforehand and we'll tell you the realistic options."
      },
      {
        question: "Will you dismantle furniture as part of the move?",
        answer: "Yes. Beds, flat-pack wardrobes, dining tables and modular sofas are routinely dismantled and rebuilt. Fixings are bagged and labelled so nothing goes missing."
      },
      {
        question: "Can flat-pack wardrobes survive being moved assembled?",
        answer: "Often not, especially tall units built in place. We'll tell you before we lift it if we think it won't travel in one piece, so you can choose between dismantling it, moving it at your own risk or replacing it."
      },
      {
        question: "How do you protect original floors and bannisters?",
        answer: "Floor protection down the hallway and stairs, padding on door frames and newel posts, and covers on mattresses and upholstery. Point out anything fragile or original at the walk-round and we'll plan the route around it."
      }
    ]
  },
  {
    id: 9,
    slug: "best-time-to-move-house-brighton-hove",
    title: "Best Time of Year (and Day) to Move House in Brighton & Hove",
    metaTitle: "Best Time to Move House in Brighton & Hove | Timing Guide | HappyVan",
    metaDescription: "When to move in Brighton and Hove: how completion days, school holidays, student cycles and city events affect availability and how smoothly your move runs.",
    excerpt: "Some moving dates are simply easier than others in this city. Here's how the Brighton calendar actually works.",
    date: "2026-06-24",
    author: "HappyVan Team",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1435527173128-983b87201f4d?w=800",
    content: `
Most people don't get to pick their moving date - a chain, a landlord or a completion decides it. But if you do have a choice, some dates are much easier than others in Brighton and Hove, and knowing the local rhythm helps even when the date is fixed.

## The weekly pattern: why Friday is chaos

Property completions cluster on Fridays. Solicitors like it, lenders like it, and everyone wants the weekend to unpack. The result is that Friday is the busiest day of the week for every removal company in the city, and the day when a late release of keys has the least slack behind it.

Friday afternoon also brings Brighton's worst traffic, particularly heading out along the coast and up the A23.

If you can choose: **Tuesday, Wednesday and Thursday are the calmest days to move.** Availability is better, the roads are quieter, and residential streets have more space once commuters have left.

Weekends are quieter on the roads but busier in the diary, and if you're completing on a purchase you generally can't move on a Saturday anyway.

## The monthly pattern: beware the month-end

Tenancies and completions bunch at the end of the month, and the last working Friday of the month is the single busiest slot in removals. Mid-month dates are far easier to book at short notice.

## The yearly pattern in this city

**Spring (March-May).** Popular and sensible. Reasonable weather, long enough days, and the market picks up so the diary fills.

**Summer (June-August).** Peak season. Families move in the school holidays so they don't disrupt term, and demand is at its highest. Long daylight hours are a genuine advantage for a big move, but book well ahead. August also brings Pride weekend, which closes roads in central Brighton and Hove and is the one weekend we'd actively avoid if you have the choice.

**September.** Brighton is a two-university city, so early autumn brings a wave of student moves. If you're moving a house at the same time, book earlier than you normally would. (If you *are* the student, see [student removals in Brighton](/student-removals-brighton).)

**Autumn (October-November).** One of the quieter, easier windows. The student rush has passed, the weather is usually workable, and availability is better. Worth noting if you're moving to [Lewes](/removals-lewes): Bonfire Night on 5 November brings significant road closures.

**December-February.** The quietest period, so availability is at its best - but daylight is short, the weather is unpredictable, and Christmas and New Year compress the working calendar. A winter move works fine with an early start and a bit of flexibility.

## Things that are worth more than the date

Whatever day you end up with, these matter more:

1. **Parking at both ends.** A suspended bay on a Friday beats a bad parking situation on a quiet Tuesday every time. See our [parking and bay suspension checklist](/blog/brighton-parking-permits-bay-suspensions-moving-checklist).
2. **Starting early.** Residential streets empty out as people leave for work, and an early start gives the whole day slack.
3. **Being properly packed.** The date doesn't matter if the kitchen cupboards are still full at 9am.
4. **Booking ahead for peak slots.** Summer, month-ends and Fridays go first.

## How far ahead should you book?

As soon as your date is firm. For peak dates - summer, month-ends, Fridays - give yourself as much notice as you can. Off-peak midweek moves are much easier to fit in at shorter notice, and we can sometimes help at very short notice, but never count on it for a completion day.

If your date is still uncertain because of a chain, tell us that when you enquire. We'd far rather hold a realistic plan and adjust than be told on the morning.

## The short version

Midweek, mid-month, outside the school holidays and away from city event days is the easiest possible move in Brighton and Hove. Everything else is manageable with parking sorted, an early start and a bit of notice.

Got a date, or two possible dates? [Call or WhatsApp us](/get-quote) and we'll tell you which one will run better. See also [house removals in Brighton](/house-removals-brighton) and our [moving cost guide](/blog/how-much-does-it-cost-to-move-house-in-brighton).
    `,
    faqs: [
      {
        question: "What's the best day of the week to move house in Brighton?",
        answer: "Tuesday, Wednesday or Thursday. Fridays are the busiest day for completions and the worst for traffic, which leaves the least slack if keys are released late."
      },
      {
        question: "Is it harder to move in the summer?",
        answer: "It's busier, not harder. Families move in the school holidays so demand peaks, and you'll need to book further ahead. The long daylight hours are a real benefit for a big move."
      },
      {
        question: "Are there dates in Brighton I should avoid completely?",
        answer: "Pride weekend in August and other major event days bring road closures in central Brighton and Hove. If you're moving to Lewes, avoid 5 November. Otherwise the last working Friday of any month is the most oversubscribed slot in the city."
      },
      {
        question: "How far in advance should I book my move?",
        answer: "As soon as your date is confirmed. Peak dates - summer, month-ends and Fridays - fill first. Midweek, mid-month moves can often be arranged at shorter notice."
      }
    ]
  }
];

// Generate sitemap data
export const sitemapPages = [
  { url: "/", changefreq: "weekly", priority: 1.0 },
  { url: "/services", changefreq: "monthly", priority: 0.8 },
  { url: "/get-quote", changefreq: "monthly", priority: 0.9 },
  { url: "/partners", changefreq: "monthly", priority: 0.7 },
  { url: "/privacy", changefreq: "yearly", priority: 0.3 },
  { url: "/terms", changefreq: "yearly", priority: 0.3 },
  { url: "/house-removals-brighton", changefreq: "monthly", priority: 0.8 },
  { url: "/man-and-van-brighton", changefreq: "monthly", priority: 0.8 },
  { url: "/office-removals-brighton", changefreq: "monthly", priority: 0.8 },
  { url: "/removals-hove", changefreq: "monthly", priority: 0.7 },
  { url: "/removals-east-sussex", changefreq: "monthly", priority: 0.7 },
  { url: "/packing-materials-brighton", changefreq: "monthly", priority: 0.7 },
  { url: "/blog", changefreq: "weekly", priority: 0.6 },
];
